<template>
<div class="chapter">
<div class="inner_page">
<section class="element element-non-bodymatter element-container-single element-type-dedication element-with-heading" epub:type="dedication" id="dedication" role="doc-dedication">
<div class="heading heading-with-title heading-without-image" id="dedication-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">Dedication</h1>
</div>
</div>
</div>
</div>
<div class="text" id="dedication-text">
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center dedication-content">To Dr. Te Lou Tchang,</p>
<p class="alignment-block-content alignment-block-content-center dedication-content">who was father-in-law,</p>
<p class="alignment-block-content alignment-block-content-center dedication-content">friend, and inspiration,</p>
<p class="alignment-block-content alignment-block-content-center dedication-content">I dedicate</p>
<p class="alignment-block-content alignment-block-content-center dedication-content">this book with love,</p>
<p class="alignment-block-content alignment-block-content-center dedication-content">and a deep sense of loss.</p>
</div>
</div>
<hr class="implicit-break"/>
<p class="first first-in-chapter first-full-width dedication-content">For their time and their critical judgment, I’d like to thank Deborah Atherton, Mark J. McGarry, Victoria Schochet, Al Sirois, and of course my wife Kim—who not only read this repeatedly, but bore with me while I wrote it.</p>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?b142bf64